import { render, staticRenderFns } from "./appIngView.vue?vue&type=template&id=04937642"
import script from "./appIngView.vue?vue&type=script&lang=js"
export * from "./appIngView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports